import * as React from 'react';
import { CustomThunkDispatch } from '../../../../configureStore';
import { Field, InjectedFormProps, reduxForm } from 'redux-form';
import { FileObjectDefinition } from '../../../../components/FileInput/definitions';
import { ProcedureInstanceSegment } from '../../../../library/Instance';
import { RootState } from '../../../../rootReducer';
import { __, required } from '../../../../utilities';
import { activeAppspaceIdSelector } from '../../../../containers/App/selectors';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { loadProcedureInstanceById } from '../../actions';
import { procedureInstanceDetailSelector } from '../../selectors';
import Col, { Row } from '@sportnet/ui/Grid';
import FileInputRedux from '../../../../components/FileInput/redux-form';
import FormField from '@sportnet/ui/FormField/redux-form';
import FormGroup from '@sportnet/ui/FormGroup';
import api from '../../../../api';

interface IFormData {
  note: string;
  files: FileList;
}
interface OwnProps {
  form: string;
  segment: ProcedureInstanceSegment;
  initialValues: {
    note?: string;
    files?: Array<{}>;
  };
  handleClose: () => void;
  readonly: boolean;
}

const mapStateToProps = (state: RootState, props: OwnProps) => ({
  instance: procedureInstanceDetailSelector(state),
  appSpace: activeAppspaceIdSelector(state),
});
type IMapStateToProps = ReturnType<typeof mapStateToProps>;

type Props = OwnProps &
  IMapStateToProps & {
    dispatch: CustomThunkDispatch;
  } & InjectedFormProps<IFormData, OwnProps>;

const ProcedureInstanceSegmentReportForm: React.FC<Props> = ({
  appSpace,
  instance,
  segment,
  readonly = false,
}) => {
  const onFileClick = async (file: FileObjectDefinition) => {
    if (!instance || file._new) {
      return;
    }
    if (file.fileid) {
      const { downloadId } = await api.getSegmentReportFile(
        appSpace,
        instance._id,
        segment._id,
        file.fileid
      );
      window.open(
        `${process.env.REACT_APP_CONTROLLING_API_BASE_URL}/downloader/${downloadId}`
      );
    }
  };

  const isOwner = instance && instance.createdByAppSpace._id === appSpace;

  return (
    <Row>
      {!readonly && (
        <Col xs={12}>
          <FormGroup>
            <Field
              component={FileInputRedux}
              id={segment._id}
              onFileClick={onFileClick}
              name="files"
              disabled={!isOwner}
              multiple
            />
          </FormGroup>
        </Col>
      )}
      <Col xs={12}>
        <Field
          component={FormField}
          required
          validate={[required]}
          readOnly={!isOwner || readonly}
          type="textarea"
          name="note"
          label={__('Poznámka')}
        />
      </Col>
    </Row>
  );
};

export default compose(
  connect(mapStateToProps),
  reduxForm<IFormData, Props>({
    enableReinitialize: true,
    onSubmit: async (values: any, dispatch: any, props: any) => {
      if (props.instance) {
        const { files } = values;
        let uploadedFiles = [];
        if ((files || []).length > 0) {
          let reducedFiles: File[] = [];
          reducedFiles = Array.from(
            files as Array<{ file: File; fileid: string }>
          ).reduce((acc: File[], file: { file: File; fileid: string }) => {
            if (file.fileid) {
              return acc;
            }
            return [...acc, file.file];
          }, []);
          const promises: Array<Promise<any>> = [];
          reducedFiles.forEach((file: File) => {
            promises.push(
              api.uploadInstanceFile(
                props.appSpace,
                props.instance ? props.instance._id : '',
                undefined,
                {
                  upload: file,
                }
              )
            );
          });
          uploadedFiles = await Promise.all(promises);
        }
        await api.appendInstanceSegmentReport(
          props.appSpace,
          props.instance._id,
          props.segment._id,
          undefined,
          { ...values, files: uploadedFiles }
        );
        props.dispatch(
          loadProcedureInstanceById.action({ id: props.instance._id })
        );
      }
      props.handleClose();
    },
  })
)(ProcedureInstanceSegmentReportForm);
